var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCloudhosting(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 64,
    height: 64.001,
    viewBox: "0 0 64 64.001",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.642,
    y1: 0.015,
    x2: 0.618,
    y2: 0.979,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e4002f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0804b5"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Cloud_Hosting",
    "data-name": "Cloud Hosting",
    transform: "translate(-2 -1.999)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Union_1",
    "data-name": "Union 1",
    d: "M10550.931-1450a2.132,2.132,0,0,1-2.132-2.132,2.133,2.133,0,0,1,2.132-2.135h4.271v-4.265h-4.268a4.273,4.273,0,0,1-4.268-4.267v-2.132h-21.332v2.132a4.273,4.273,0,0,1-4.268,4.267h-4.267v4.265h4.267a2.133,2.133,0,0,1,2.133,2.135,2.133,2.133,0,0,1-2.133,2.132h-12.8a2.133,2.133,0,0,1-2.133-2.132,2.133,2.133,0,0,1,2.133-2.135h4.268v-4.265h-4.265a4.273,4.273,0,0,1-4.268-4.267v-8.535a4.271,4.271,0,0,1,4.268-4.265h12.8a4.271,4.271,0,0,1,4.268,4.265v2.135h8.532V-1482h-12.8a4.272,4.272,0,0,1-3.7-2.135h-2.7c-5.883,0-10.667-4.488-10.667-10a10.22,10.22,0,0,1,8.7-9.837c1-5.68,6.283-10.026,12.632-10.026a13.043,13.043,0,0,1,10.666,5.364,13.044,13.044,0,0,1,10.666-5.364c6.35,0,11.63,4.345,12.629,10.026a10.22,10.22,0,0,1,8.705,9.837c0,5.517-4.784,10-10.667,10h-2.7a4.272,4.272,0,0,1-3.7,2.135h-12.8v12.8h8.532v-2.135a4.271,4.271,0,0,1,4.268-4.265h12.8a4.269,4.269,0,0,1,4.267,4.265v8.535a4.271,4.271,0,0,1-4.267,4.267h-4.268v4.265h4.268a2.134,2.134,0,0,1,2.135,2.135,2.133,2.133,0,0,1-2.135,2.132Zm0-12.8h12.8l0-8.535h-12.8v8.535Zm-42.666,0h12.8l0-4.159q0-.054,0-.109c0-.035,0-.07,0-.1l0-4.162h-12.8Zm42.666-23.467v-4.259l-29.867-.008v4.267h29.867Zm6.4-2.132c3.53,0,6.4-2.575,6.4-5.739s-2.87-5.74-6.4-5.74a2.132,2.132,0,0,1-2.132-2.132v-.011c0-4.251-3.827-7.713-8.535-7.713s-8.532,3.461-8.532,7.713v.825a2.133,2.133,0,0,1-2.133,2.132,2.133,2.133,0,0,1-2.135-2.132v-.825c0-4.251-3.827-7.713-8.532-7.713s-8.534,3.461-8.534,7.713c0,0,0,0,0,.005s0,0,0,.005a2.133,2.133,0,0,1-2.133,2.132c-3.53,0-6.4,2.575-6.4,5.74s2.869,5.739,6.4,5.739h2.133v-2.135a4.272,4.272,0,0,1,4.267-4.267h29.867a4.273,4.273,0,0,1,4.268,4.267v2.135Zm-4.268-2.135h0Z",
    transform: "translate(-10502 1516)",
    fill: "url(#linear-gradient)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloudhosting);
export default __webpack_public_path__ + "static/media/cloudhosting.884e7e7c3a0fb2045147b61f6b6cdc05.svg";
export { ForwardRef as ReactComponent };